import { getTriggerFromExternalStore } from '../TriggerFromExternal/useTriggerFromExternalStore';
import { getPerformActionExternalStore } from '../PerformActionExternal/usePerformActionExternalStore';
import { getPipedreamTriggers, getPipedreamActions } from '../../utils/PipeDreamUtil';

/**
 * Drives the shared External-App UI (inline node config + full-pane template). The trigger and action
 * components are structurally identical; they differ only in labels, the Pipedream capability filter,
 * the component-list fetcher, the persisted item-key/version fields, the output-placeholder prefix,
 * and the store. This descriptor captures those differences so one implementation serves both.
 *
 * - `capability`        — passed to PipedreamAppSearchPicker / apps search to filter the catalog.
 * - `fetchItems(slug)`  — returns the app's trigger/action component list (array).
 * - `selectedKeyField`  — component-data field holding the selected component key.
 * - `commitSelectedItem(store, item)` — writes the selected item into the keyed store (the store also
 *   persists any version field, e.g. selectedActionVersion, internally).
 */
export const EXTERNAL_APP_CAPABILITIES = {
  trigger: {
    componentType: 'trigger_from_external_app',
    capability: 'triggers',
    nodeLabel: 'External App Trigger',
    itemLabel: 'Select an Event',
    itemPlaceholder: 'Search for an event...',
    loadingText: 'Loading triggers...',
    outputPrefix: 'external_trigger_',
    getStore: getTriggerFromExternalStore,
    fetchItems: getPipedreamTriggers,
    selectedKeyField: 'selectedTriggerKey',
    commitSelectedItem: (store, item) => store.getState().setSelectedTrigger(item || {}),
  },
  action: {
    componentType: 'perform_action_in_external_app',
    capability: 'actions',
    nodeLabel: 'External App Action',
    itemLabel: 'Select an Action',
    itemPlaceholder: 'Search for an action...',
    loadingText: 'Loading actions...',
    outputPrefix: 'external_action_',
    getStore: getPerformActionExternalStore,
    fetchItems: getPipedreamActions,
    selectedKeyField: 'selectedActionKey',
    commitSelectedItem: (store, item) => store.getState().setSelectedAction(item || {}),
  },
};
